import Take from "../models/Take";
import Take3D from "../models/Take3D";
import Interaction from "../models/interactions/Interaction";
import { getKeysFromInteraction } from "./KeysHelper";

export interface TakeDeletionCleanup {
  localizationKeys: string[];
  validationInteractionIds: string[];
}

/**
 * Collects document and derived-state records owned by a Take. Interaction
 * containers are explicit so unrelated Take fields that happen to start with
 * `key_` can never be mistaken for localization keys.
 */
export function collectTakeDeletionCleanup(take: Take): TakeDeletionCleanup {
  const take3D = take as Take &
    Partial<Pick<Take3D, "mainCamera" | "sequence" | "transition">>;
  const interactionRoots: Interaction[] = [...(take.interactions ?? [])];

  if (take3D.transition) interactionRoots.push(take3D.transition);
  if (take3D.sequence) interactionRoots.push(take3D.sequence);

  const localizationKeys = new Set<string>();
  interactionRoots.forEach((interaction) => {
    getKeysFromInteraction(interaction, "key_").forEach((key) =>
      localizationKeys.add(key),
    );
  });

  const validationInteractionIds = new Set(
    interactionRoots.map((interaction) => interaction.id).filter(Boolean),
  );
  if (take3D.mainCamera?.id) {
    validationInteractionIds.add(take3D.mainCamera.id);
  }

  return {
    localizationKeys: [...localizationKeys],
    validationInteractionIds: [...validationInteractionIds],
  };
}
